import { createSelector } from 'reselect';
import { getSearchAsObject } from '@shared/selectors';
import { QUERY_PARAM } from '@commons/constants';

const getAddLineFeaturedProduct = createSelector(
  getSearchAsObject,
  queryString =>
    (queryString && queryString[QUERY_PARAM.FEATURED_PRODUCT_CONFIG]) || null,
);

export default getAddLineFeaturedProduct;
